import service from '@/api/patientTasks';
import {loading, alert, handleError} from '@/state/generators/helpers';

export const state = {
    service: service,
    today: []
};

export const getters = {
    today: function (state) {
        return state.today;
    }
};

export const mutations = {
    'SET_TODAY': function (state, tasks = []) {
        state.today = tasks;
    },
    'REPLACE_TODAY_ITEM': function (state, item) {
        const index = state.today.findIndex(task => task.id === item.id);

        if (index !== -1) {
            state.today[index] = item;
            state.today = JSON.parse(JSON.stringify(state.today));
        }
    }
};

export const actions = {
    today: function ({commit, state}) {
        loading(commit);

        return state.service.fetchToday().then(response => {
            commit('SET_TODAY', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    complete: function ({commit, state}, {id, data}) {
        loading(commit);

        return state.service.complete(id, data).then(response => {
            commit('REPLACE_ITEM', response.data);
            commit('REPLACE_TODAY_ITEM', response.data);
            commit('SET_ITEM', response.data);
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    skip: function ({commit, state}, id) {
        loading(commit);

        return state.service.skip(id).then(response => {
            commit('REPLACE_ITEM', response.data);
            commit('REPLACE_TODAY_ITEM', response.data);
            commit('SET_ITEM', response.data);
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    revert: function ({commit, state}, id) {
        loading(commit);

        return state.service.revert(id).then(response => {
            commit('REPLACE_ITEM', response.data);
            commit('REPLACE_TODAY_ITEM', response.data);
            commit('SET_ITEM', response.data);
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    }
};
